export default "__VITE_PUBLIC_ASSET__a52e2c3a__"